import {useRef, useEffect, useState} from 'react'; 
import Select, { components } from 'react-select'
import { observer } from 'mobx-react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.css';
import lang from "../../lang";
import {Bar} from "react-chartjs-2"
import {Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend} from 'chart.js'
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
import GlobalState, {
    changepopupDeployment, 
    changedatasetflag, 
    changepopupdeleteShedule,
    addsegmentdeploymass1,
    addsegmentdeploymass2,
    changesegmentationpage,
    changemikrosegmentations,
    changeIDdeletecolumn,
    changepopupdeleteColumn,
    changepopupaddSegment,
    minusnumpagesmodelsportraits,
    plusnumpagesmodelsportraits,
    changepopupdeleteTable,
    setifblock,
    setifblockNull,
    changepopupdeleteClause,
    changesegmentationpagecenter1,
    changePortraitsheduledeployname,
    changePortraitsheduledeployname2,
    changepopupCloseSelectAttribute,
    changepopupCloseEditDeploy,
    changepopupcloseShedule,
    setEvery,
    setHour,
    setMinut} from "../../stores/GlobalState";

import Domen from "../../stores/Domen";
import Loading from '../common/loading';
import LoadingCompleted from '../common/loading_completed';
import LoadingFail from '../common/loading_fail';
import StartPage from './page/StartPage';
import ListSermentations from './module/listsegmentacions'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { GetDataPortrait } from './module/GetDataPortrait';
import { GetDatasetsForPortrait } from './module/GetDatasetsForPortrait';
import { GetDataDeployPreview } from './module/GetDataDeployPreview';
import { getLinkOutline } from './module/GetLinkOutline';
import { PostLinkOutlineBig } from './module/PostLinkOutlineBig';
import { PostLinkOutlineBigNoSchedule } from './module/PostLinkOutlineBigNoSchedule';
import { AddAttributesFromFile } from "./module/AddAttributesFromFile";
import { EditAttributeName } from "./module/EditAttributeName";
import { getColumnInfo } from "./module/GetColumnInfo";
import SecondPage from "./page/SecondPage";
import SelectAttributeFilePage from "./page/SelectAttributeFilePage";
import EditAttributeFilePage from "./page/EditAttributeFilePage";
import CreateSegmentation from "./page/CreateSegmentation";
import EditSegmentation from "./page/EditSegmentation";
import DeployFirstPage from "./page/DeployFirstPage";
import DeploySecondPage from "./page/DeploySecondPage";


import AttachmentBoxAnaliticsbigexport from "./module/AttachmentBoxAnaliticsbigexport";
import AttachmentBoxAnaliticsbigOnetimeexport from "./module/AttachmentBoxAnaliticsbigOnetimeexport";


const Sidebar = observer(() => {
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [mass1, setMass1] = useState([]);
    const [mass2, setMass2] = useState([]);
    const [textinselect, setTextinselect] = useState("0");
    const [textloading, setTextloading] = useState(langv?.loading?.workspace?.text1);
    const [textloadingcompleated, setTextloadingcompleated] = useState(langv?.loading?.workspace?.text2);
    const [textloadingdeploy, setTextloadingdeploy] = useState("Deployment in progress <br/><span>Please wait or close the window while the model is being deployed</span>");
    const [textloadingdeployexport, setTextloadingdeployexport] = useState("Export with schedule in progress <br/><span>Please wait </span>");
    const [textloadingdeployexportonetime, setTextloadingdeployexportonetime] = useState("Big Query  one time export in progress <br/><span>Please wait </span>");
    const [textloadingcompleateddeploy, setTextloadingcompleateddeploy] = useState("Processing the saving of deployment");
    const [textloadingcompleatedexport, setTextloadingcompleatedexport] = useState("Scheduled export was successful");
    const scrollRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [columnName, setColumnName] = useState("");
    const [updateselect, setUpdateselect] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);
    var count = Math.trunc((height*1-320)/35);
    const [limit, setLimit] = useState(count);
    const [activedataset, setActivedataset] = useState([]);
    const [openselect, setOpenselect] = useState(false);
    const [inputNameColumn, setInputNameColumn] = useState();
    const [optionscsw, setOptionscsw] = useState("");
    const [activeDataset, setActiveDataset] = useState("");
    const [activeexportblock1, setActiveexportblock1] = useState(false);
    const [activeexportblock2, setActiveexportblock2] = useState(true);
    const [editDataset, setEditDataset] = useState("");
    const [typeDeploy, setTypeDeploy] = useState(0);
    const [nameDatasetprew, setNameDatasetprew] = useState(GlobalState.portraitsheduledeployname||"");
    const [nameDatasetprew2, setNameDatasetprew2] = useState(GlobalState.portraitsheduledeployname2||"");
    const [attachments, setAttachments] = useState([]);
    const [load, setLoad] = useState(0);
    const [deployprew, setDeployprew] = useState([]);
    const [polden, setPolden] = useState(2);
    const [startDate, setStartDate] = useState(new Date());
    const [masscheca, setMasscheca] = useState([]);
    const [masscheca_order, setMasscheca_order] = useState([]);
    const [masschecadataset, setMasschecadataset] = useState([]);
    const [inputt1, setInputt1] = useState("");
    const [inputt2, setInputt2] = useState("");
    const [inputt4, setInputt4] = useState("");
    const [v1_export, setV1_export] = useState(false);
    const [v2_export, setV2_export] = useState(false);
    const [v3_export, setV3_export] = useState(false);
    const [v4_export, setV4_export] = useState(false);
    const [countword, setCountword]=useState(0);
    const [countwordLast, setCountwordLast]=useState(0);
    const blockRef = useRef(null);
    const blockRef2 = useRef(null);
    const [widthselect, setSelect] = useState(0);
    const [widthselect2, setSelect2] = useState(0);
    const [errorNameAttr, setErrorNameAttr]=useState(false);
    const [elseval, setElseval] = useState("");
    const [optionif, setOptionif] = useState("");
    const [closeExport1, setCloseExport1] = useState("");
    const [closeExport3, setCloseExport3] = useState("");
    const [closeExport4, setCloseExport4] = useState("");
    const [closeExport5, setCloseExport5] = useState("");
    const [closeExport6, setCloseExport6] = useState("");


    var countnowword = 0;
    let hours = [];
    for(var i = 1; i<=12; i++){hours = [...hours, { value: i, label: i }]}
    let days = [{ value: "daily", label:"Day" },{ value: "weekly", label:"Week" },{ value: "monthly", label: "Month" }]
    let optionoper = [{ value: ">=", label: ">=" }, { value: "=", label: "=" }, { value: "<=", label: "<=" }, { value: "<", label: "<" }, { value: ">", label: ">" }];
    let optionopercat = [ { value: "=", label: "=" }, { value: "≠", label: "≠" }, ];
    var labels = [];
    var datalabels = [];
    

    const handleScroll = () => {
        const element = scrollRef.current;
        if (element) {
            const scrollLeft = element.scrollLeft;
            const scrollWidth = element.scrollWidth - element.clientWidth;
            const scrolled = (scrollLeft / scrollWidth) * 100;
            setScrollPosition(scrolled);
        }
    };
    useEffect(() => {
        const element = scrollRef.current;
        if (element) {
          element.addEventListener("scroll", handleScroll);
        }
        return () => {
          if (element) {
            element.removeEventListener("scroll", handleScroll);
          }
        };
    }, []);
    setTimeout(function(){
        const element = scrollRef.current;
        if (element) {
          element.addEventListener("scroll", handleScroll);
        }
        return () => {
          if (element) {
            element.removeEventListener("scroll", handleScroll);
          }
        };
    }, 1000);
    useEffect(()=>
    {
        var t = [];
        masscheca.map((n, id)=>
            t = [...t, {id: n.id, value: n.title, label: n.title }]
        )
        setOptionif(t);
        const element = scrollRef.current;
        if (element) {
          element.addEventListener("scroll", handleScroll);
        }
        return () => {
          if (element) {
            element.removeEventListener("scroll", handleScroll);
          }
        };
    },[masscheca])
    if(GlobalState.datasetflag==0){ 
        GetDataPortrait();
        GetDatasetsForPortrait({scrollRef,handleScroll,setOptionscsw});
        GetDataDeployPreview(setDeployprew);
        changedatasetflag(1);
        setTimeout(function(){
             updateWord();
        }, 2000)
       
    }
    const changepopupDeployment0 = () =>
    {
        if(mass1.length>0||mass2.length>0)
        {
            addsegmentdeploymass1(mass1);
            addsegmentdeploymass2(mass2);
            changepopupDeployment();
        }
    }
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '100%',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 16,
        }),
        input: (provided) => ({
            ...provided,
            color: "rgba(245, 197, 56, 1)",
        }),
        menu: (provided) => ({
            ...provided,
           
            width: '100%',
            border: '1px solid rgba(229, 229, 234, 1)',
            marginTop: '-9px',
            BorderTop: '0px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(2, 2, 3, 1)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(2, 2, 3, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(45, 50, 57, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(45, 50, 57, 1))', 
            }
            }),
    };
    const customStyles2 = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '187px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '1px solid rgba(216, 221, 228, 1)',
            boxShadow: 'none',
            fontSize: 16,
            zIndex:9999999,
            position:'relataive',
            borderRadius: "8px",
            marginRight: "20px"
        }),
        input: (provided) => ({
            ...provided,
            color: "rgba(245, 197, 56, 1)",
        }),
        menu: (provided) => ({
            ...provided,
            background: 'rgba(255, 255, 255, 1)',
            width: '187px',
            border: '1px solid rgba(216, 221, 228, 1)',
            marginTop: '-7px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(245, 197, 56, 1)',
            zIndex:9999,
            position:'absolute'
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 16,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(245, 197, 56, 1)' : 'rgba(2, 2, 3, 1)',
            zIndex:9999,
            position:'relative',
            backgroundColor: 'rgba(2, 2, 3, 0)', 
            '&:hover': {
                color: 'rgba(245, 197, 56, 1)',
                backgroundColor: 'rgba(245, 197, 56, 0)'
            },
            '&:focus': {
                color: 'rgba(245, 197, 56, 1)', 
                backgroundColor: 'rgba(245, 197, 56, 0)'
            },
            '&:active': {
                color: 'rgba(245, 197, 56, 1)', 
                backgroundColor: 'rgba(245, 197, 56, 0)'
            }
            }),
        placeholder: (provided) => ({
        ...provided,
        color: 'rgba(2, 2, 3, 0.6)', // 👈 Тут ставиш свій колір
    }),
    };
    const customStylesif = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '310px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 16,
            
            
        }),
        input: (provided) => ({
            ...provided,
            color: "rgba(245, 197, 56, 1)",
        }),
        menu: (provided) => ({
            ...provided,
           
            width: '310px',
            border: '1px solid rgba(229, 229, 234, 1)',
            marginTop: '-9px',
            BorderTop: '0px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(2, 2, 3, 1)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(2, 2, 3, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(45, 50, 57, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(45, 50, 57, 1))', 
            }
            }),
    };
    const customStylesoper = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '95%',
            minWidth: '95%',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 16,
        }),
        input: (provided) => ({
            ...provided,
            color: "rgba(245, 197, 56, 1)",
        }),
        menu: (provided) => ({
            ...provided,
           
            width: '95%',
            border: '1px solid rgba(229, 229, 234, 1)',
            marginTop: '-9px',
            BorderTop: '0px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(2, 2, 3, 1)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(2, 2, 3, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(45, 50, 57, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(45, 50, 57, 1))', 
            }
            }),
    };
    const DropdownIndicator = props => {
        return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {
                props.selectProps.menuIsOpen ? 
                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6.84706" cy="9.96229" r="1.53846" fill="#020203"/>
                        <circle cx="6.84706" cy="9.96229" r="1.53846" fill="black" fill-opacity="0.2"/>
                        <circle cx="6.84706" cy="9.96229" r="1.53846" fill="black" fill-opacity="0.2"/>
                        <path d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385" stroke="#020203"/>
                        <path d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385" stroke="black" stroke-opacity="0.2"/>
                        <path d="M0.691406 7.65385L7.03173 1.5L12.9991 7.65385" stroke="black" stroke-opacity="0.2"/>
                    </svg>
                    : 
                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="#020203"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fill-opacity="0.2"/>
                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fill-opacity="0.2"/>
                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="#020203"/>
                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" stroke-opacity="0.2"/>
                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" stroke-opacity="0.2"/>
                    </svg>
                }
            </components.DropdownIndicator>
        )
        );
    };
    const setOptionmetrics0 = (a)=>
    {
        setActiveDataset(a)
        getColumnInfo(a, setMasscheca, setActivedataset, setUpdateselect)
    }
    const setOptionmetricsforcreate = (a)=>
    {
        setUpdateselect(true)
        var t = [{then:"", list:[{title: "if", activColumn: "", type:"", operator:[{operator:"", value:"", select:false}]}]}];
        setifblock(t);
        setActiveDataset(a)
        getColumnInfo(a, setMasscheca, setActivedataset, setUpdateselect)
        setElseval('');
    }
    const setOptionmetricsattr1 = (a)=>
    {
       
        setActiveDataset(a);
        var t = [];
        GlobalState.dataset?.map((n, id)=>
            n.id==a?
                n.columnsName?.map((z, i)=>
                    t = [...t, {id: i, check: false, title: z}]
                )
            :
            <></>
        )

        setMasscheca(t);
        setTextinselect(0);
        
    }
    const setOptionmetrics1 = (a, vid, vid2)=>
    {
        var t = [];
        var l = [];
        var op = [];
        var atrim = GlobalState.ifblock;
        setifblock([]);
        atrim.map((n, id)=>
        {
            if(id == vid)
            {
                l = [];
                
                n.list?.map((y, id2)=>{
                    op = [];
                    if(id2 == vid2){
                        
                        activedataset.map((u)=>{
                            
                            if(a==u.title){
                                y.operator?.map((v)=>
                                    op = [...op, {operator: v.operator, value: u.categories, select: v.select} ]
                                )
                                l = [...l, {title: y.title, activColumn: a, type: u.type, operator: op}]
                            }
                        })
                    
                    }
                    else
                    {
                        l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                    }    
                })
                t = [...t, {then: n.then, list: l}]
                
            }
            else
            {
                t = [...t, {then: n.then, list: n.list}]
            }
        })
        
        setifblock(t);
        
       
    }
    const setOperator = (a, vid, vid2, f)=>
    {
        var t = [];
        var l = [];
        var op = [];
        console.log("trefa")
        GlobalState.ifblock.map((n, id)=>
        {
            if(id == vid)
            {
                l = [];
                n.list?.map((y, id2)=>{
                    if(id2 == vid2){
                        op = [];
                        y.operator?.map((v, g)=>{
                            if(g==f)
                            {
                                op = [...op, {operator:a, value:v.value, select: v.select} ]
                            }
                            else
                            {
                                op = [...op, {operator:v.operator, value:v.value, select: v.select} ]
                            }
                        })
                        l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: op}] // tut
                    }
                    else{
                        l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                    }
                })
                t = [...t, {then: n.then, list: l}]
            }
            else
            {
                t = [...t, {then: n.then, list: n.list}]
            }
        })
        setifblock(t);
        
    }
    const changeThen = (a, vid)=>
        {
            var t = [];
            var l = [];
            GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    t = [...t, {then: a, list: n.list}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            setifblock(t);
    }
    const addNewLine = ()=>
        {
            var t = [];
        
            t = [...GlobalState.ifblock, {then:"", list:[{title: "if", activColumn: "", operator:[{operator:"", value:"", select: false}]}]}]
                
           
            setifblock(t);
    }
    const addNewLinesub = (vid)=>
        {
            var t = [];
            var l = [];
            GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l = [...n.list, {title: "and", activColumn: "", operator:[{operator:"", value:"", select: false}]}];
                    
                    t = [...t, {then: n.then, list: l}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            setifblock(t);
    }
    const addNewLinesubsub2 = (vid, vid2)=>
    {
            var t = [];
            var l = [];
            var l0 = [];
            var op = [];
            GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l0 = [];
                    op = [];
                    n.list?.map((y, id2)=>
                    {
                        if(id2 == vid2)
                        {
                            if(y.type=="categorical")
                            {
                                activedataset.map((u)=>{
                                    if(y.activColumn==u.title){
                                        op = [...y.operator, {operator:"", value: u.categories, select: false}];
                                    }
                                })
                            }
                            else
                            {
                                op = [...y.operator, {operator:"", value:"", select: false}];
                            }
                            
                            l0 = [...l0, {title: y.title, type: y.type, activColumn: y.activColumn, operator: op}];
                        }
                        else
                        {
                            l0 = [...l0, y];
                        }
                    })
                    t = [...t, {then: n.then, list: l0}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            console.log(JSON.stringify(t)+ "ytr255")
            setifblock(t);
    }
    const addNewLinesubsub3 = (vid, vid2)=>
    {
            var t = [];
            var l = [];
            var l0 = [];
            var op = [];
            GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l0 = [];
                    op = [];
                    n.list?.map((y, id2)=>
                    {
                        if(id2 == vid2)
                        {
                            if(y.type=="categorical")
                            {
                                activedataset.map((u)=>{
                                    if(y.activColumn==u.title){
                                        op = [...y.operator, {operator:"", value: u.categories, select: false}];
                                    }
                                })
                            }
                            else
                            {
                                op = [...y.operator, {operator:"", value:"", select: false}];
                            }
                            
                            l0 = [...l0, {title: y.title, type: y.type, activColumn: y.activColumn, operator: op}];
                        }
                        else
                        {
                            l0 = [...l0, y];
                        }
                    })
                    t = [...t, {then: n.then, list: l0}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            setifblock(t);
    }
    const checkmultiselect = (a)=>{
        
        var t = [];
        var c = masscheca_order;
        masscheca.map((z, id)=>
            z.id==a?

                z.check==true? t = [...t, {id: z.id, check:false, title: z.title}]: t = [...t, {id: z.id, check:true, title: z.title}]
            :
            t = [...t, {id: z.id, check:z.check, title: z.title}]
        )
        setMasscheca(t)

       
        t.map((z, id)=>
            id==a?

                z.check==true? c = [...c, {id: z.id, check:true, title: z.title}]
                : 
                c = c.filter(item => item.title !== z.title)
            :
            <></>
           
        )
        setMasscheca_order(c);

        var or = 0;
        t.map((o, id)=>
            o.check==true?or=1:<></>
        )
        or==1?setTextinselect(1):setTextinselect(0);
       
        setOpenselect(true);
        setTimeout(setOpenselect(true), 500)
    }
    const checkmultiselectmulty = (a, vid, vid2, tg, f)=>{
        var t = [];
        var l = [];
        var l2 = [];
        var op = [];
        // console.log(a + " - "  + vid + " - "+ vid2 + " - "+ tg + " - " + f)
        // console.log(JSON.stringify(GlobalState.ifblock) + "yu")
        GlobalState.ifblock.map((n, id)=>
        {
            if(id == vid)
            {
                l = [];
                n.list?.map((y, id2)=>
                {
                    if(id2 == vid2){
                        
                        op = [];
                        y.operator?.map((v, g)=>{
                            l2 = [];
                            Array.isArray(v.value)? 
                            v.value?.map((gh, oi)=>
                                oi==a?

                                l2 = [...l2,{check: !gh.check, name: gh.name}]
                                :
                                l2 = [...l2,{check: gh.check, name: gh.name}]
                            )
                            :
                            <></>

                            if(g==f)
                            {
                                op = [...op, {operator:v.operator, value:l2, select: v.select} ]
                            }
                            else
                            {
                                op = [...op, {operator:v.operator, value:v.value, select: v.select} ]
                            }
                        })
                        l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: op}] //tut
                    }
                    else
                    {
                        l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                    }
                })
                t = [...t, {then: n.then, list: l}]
            }
            else
            {
                t = [...t, {then: n.then, list: n.list}]
            }
        })

        setifblock(t);
        setTextinselect(1);
    }
    const setOpenselectful = (vid, vid2, f) =>{
        var t = [];
        var l = [];
        var op = [];
        GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l = [];
                    n.list?.map((y, id2)=>
                    {
                        if(id2 == vid2){
                            op = [];
                            y.operator?.map((v, g)=>{
                                if(g==f)
                                {
                                    op = [...op, {operator:v.operator, value:v.value, select: true} ]
                                }
                                else
                                {
                                    op = [...op, {operator:v.operator, value:v.value, select: v.select} ]
                                }
                            })
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: op}] 
                        }
                        else{
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                        }
                    })
                    t = [...t, {then: n.then, list: l}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            setifblock(t);
    }
    const setOpenselectful2 = (vid, vid2, f) =>{
        var t = [];
        var l = [];
        var op = [];
        GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l = [];
                    n.list?.map((y, id2)=>
                    {
                        if(id2 == vid2){
                            op = [];
                            y.operator?.map((v, g)=>{
                                if(g==f)
                                {
                                    op = [...op, {operator:v.operator, value:v.value, select: false} ]
                                }
                                else
                                {
                                    op = [...op, {operator:v.operator, value:v.value, select: v.select} ]
                                }
                            })
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: op}] 
                        }
                        else{
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                        }
                    })
                    t = [...t, {then: n.then, list: l}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
        })
        setifblock(t);
    }
    const setValueselect = (a, vid, vid2, f)=>
        {
            var t = [];
            var l = [];
            var op = [];

            // Забороняємо літери та пробіли
            a = a.replace(/[a-zA-Z\s]/g, '');

            // Залишаємо тільки цифри та крапку
            a = a.replace(/[^0-9.]/g, '');

            // Дозволяємо тільки одну крапку
            const parts = a.split('.');
            if (parts.length > 2) {
                a = parts[0] + '.' + parts[1];
            }

            console.log(a);

            GlobalState.ifblock.map((n, id)=>
            {
                if(id == vid)
                {
                    l = [];
                    n.list?.map((y, id2)=>
                    {
                        if(id2 == vid2){
                            op = [];
                            y.operator?.map((v, g)=>{
                                if(g==f)
                                {
                                    op = [...op, {operator:v.operator, value:a, select: v.select} ]
                                }
                                else
                                {
                                    op = [...op, {operator:v.operator, value:v.value, select: v.select} ]
                                }
                            })
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: op}] // tut
                        }
                        else{
                            l = [...l, {title: y.title, activColumn: y.activColumn, type: y.type, operator: y.operator}]
                        }
                    })
                    t = [...t, {then: n.then, list: l}]
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            setifblock(t);
    }
    const resetcheck = ()=>{
        var t = [];
        masscheca.map((z, id)=>
           
            t = [...t, {check:false, title: z.title}]
        )
        setMasscheca(t)
        setTextinselect(0)
        setTimeout(function(){
            setOpenselect(false)
        }, 200)
    }
    const AddAttributesFile = ()=>{
        var t = [];
        t = [...t, {title: GlobalState.segmentationitems[0].title, titletext: GlobalState.segmentationitems[0].titletext, list: GlobalState.segmentationitems[0].list }];
        masscheca_order.map((n, id)=>
            n.check==true?
            t = [...t, {id: n.id, title: n.title, titletext:"", list:["test", "test","test", "test","test", "test","test", "test","test", "test","test", "test","test", "test"]}]
            :
            <></>
        )
        changemikrosegmentations(t);
        var x = [];
        masscheca_order.map((n, id)=>
            n.check==true?
            x.push(n.title)
            :
            <></>
        )
        AddAttributesFromFile(activeDataset, x);
    }  
    const editAttributeparam = async(u)=>{
       
        
        var t = [];
        var id_d = '';
        GlobalState.dataset?.map((n, id)=>
            n.name == activeDataset?id_d=n.id:<></>
        )  
        var rules = [];
        var l = [];
        var l2 = [];
        // console.log(JSON.stringify(GlobalState.ifblock) + "665544");
        GlobalState.ifblock.map((n, id)=>
        {
            l = [];
            n.list?.map((g, id2)=>
            {
                
                if(g.type=="categorical")
                {
                    l2 = [];
                    
                    g.operator?.map((v, f)=>{
                        l2 = [];
                        Array.isArray(v.value)? 
                        v.value?.map((gh)=>
                        {
                            if(gh.check==true)
                            {
                                l2 = [...l2, gh.name]
                            }
                        }
                        )
                        :
                        <></>

                        l = [...l, {column: g.activColumn, operator: v.operator, value: l2}]
                    })
                    
                }
                else
                {
                    g.operator?.map((v, f)=>{
                        l = [...l, {column: g.activColumn, operator: v.operator, value: v.value}]
                    })
                }
                
            }
            )
            rules = [...rules,{conditions: l, newValue: n.then} ]
        }
        )
        if(rules[0].conditions[0].column!='')
        {
            var token = localStorage.getItem("token");
            if(u==1)
            {
                var attr = {
                    datasetId: activeDataset,
                    rules: rules,
                    rewrite: false,
                    newColumnName: inputNameColumn,
                    othersValue: elseval
                };
            }
            else
            {
                var attr = {
                    datasetId: activeDataset,
                    rules: rules,
                    rewrite: true,
                    newColumnName: inputNameColumn,
                    othersValue: elseval
                };
            }
            

            localStorage.setItem("countactivetime", Date.now());
            const allFilled = rules.every(rule =>
                Object.values(rule).every(value => value !== undefined && value !== null && value !== '')
            );
            if(allFilled){
                const response = await fetch(Domen.url + `portraits/add_rule_based_attribute`, {
                    method: 'POST',
                    headers: {
                        'Authorization': token,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(attr),
                })
                if(response.status=="200"||response.status=="202")
                {
                    const data = await response.json();
                
                    //changesegmentationpage('2');
                    location.href = location.href
                }
                else
                {
                    alert("Something went wrong, request status:" + response.status)
                }
            }
        }
    }
    const EditAttributeNameAndParamNew = async(u)=>{
        if(u!=1)
        {
            EditAttributeName(inputNameColumn, inputt4) 
        }
       
        editAttributeparam(u);
    }
    const EditAttributeNameAndParam = async(u)=>{

        if(u!=1)
        {
            
            var token = localStorage.getItem("token");
            var attr = {
                name: inputNameColumn
               
            };
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `portraits/attribute/`+inputt4, {
                method: 'PUT',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(attr),
            })
            if(response.status=="200"||response.status=="202")
            {
                const data = await response.json();
                editAttributeparam(u);
            }
            else
            {
                alert("Something went wrong, request status:" + response.status)
            }
        }
        else
        {
            editAttributeparam(u);
        }
       
        

        

        

    }
    const deleteColumn = async(a, b)=>{
        changeIDdeletecolumn(b);
        changepopupdeleteColumn();  
    }   
    const changepopupaddSegment0 = ()=>{
        changepopupaddSegment();
        resetcheck();
        var t = [{then:"", list:[{title: "if", activColumn: "", operator:[{operator:"", value:"", select: false}]}]}]
        setifblock(t);
        setInputNameColumn('');
        setElseval('');
        setActiveDataset('');


        let iter = [];
        GlobalState.dataset?.map((n, id)=>

            iter.push({ value: n.id, label: n.name })
        )
        setOptionscsw(iter)

        var t = [];
        GlobalState.dataset?.map((n, id)=>
            t = [...t, {check: false, name: n.name, id: n.id }]
        )
        setMasschecadataset(t);

    }
    const changesegmentationpage6 = () =>{
        let iter = [];
        GlobalState.dataset?.map((n, id)=>
            iter.push({ value: n.id, label: n.name })
        )
        getExportShedule();
        GetDataDeployPreview(setDeployprew);
        setOptionscsw(iter)
        changesegmentationpage(6)
        changesegmentationpagecenterAll(0)
    }
    const changesegmentationpage01 = async(a, b)=>{
        let iter = [];
       
        GlobalState.dataset?.map((n, id)=>

            iter.push({ value: n.id, label: n.name })
        )
        if(b)
        {
            
            var asy = [];
            if (b.rule?.rules?.length > 0) {
                let asy = []; // треба оголосити тут, бо в твоєму коді не було

                b.rule.rules.forEach((f) => {
                    let u = [];
                    f.conditions.forEach((g) => {
                        // Якщо value — масив стрінгів, то трансформуємо
                        let value = g?.value;
                        if (Array.isArray(value) && typeof value[0] === "string") {
                            value = value.map(v => ({ check: true, name: v }));
                        }
                        u = [
                            ...u,
                            {
                                title: "if",
                                activColumn: g.column,
                                type: b.type,
                                operator: [
                                    {
                                        operator: g.operator,
                                        value: value, // тут вже або стрінги, або об'єкти
                                        select: false
                                    }
                                ]
                            }
                        ];
                    });
                    asy = [...asy, { then: f.new_value, list: u }];
                });

                console.log(JSON.stringify(asy) + " trefa");
                setifblock(asy);
                setifblockNull(asy);
                setElseval(b.rule.else);
            }

            
            setEditDataset(b.datasets[0]?.name)
            
            setOptionmetrics0(b.datasets[0]?.id)
            
            setInputNameColumn(b.name)




            setColumnName(b.datasets[0]?.source_column);

            setInputt1(b.name)
            setInputt2(b.datasets[0]?.name)

            setInputt4(b.id)

            // setEditrule(b)
            
        }

       

        //setifblock
        


        setOptionscsw(iter)
        //setOptionscswdeploy(iter)
        changesegmentationpage(a)
    }
    const getExportShedule = async() =>{
        
    }
    const setHour0 = (a) =>{
        if(a>0)
        {
            if (a <= 12) {
                setHour(a);
            }
            else
            {
                setHour(12);
            }
        }
        
    }
    const setMinut0 = (a) =>{
        if(a>=0)
        {
            if (a <= 59) {
                setMinut(a);
            }
            else
            {
                setMinut(59);
            }
        }
    }
    const changepopupdeleteClauseInside = async(id, activeDataset, im, el, vid, type, cr, f)=>{
        changepopupdeleteClause(id, activeDataset, im, el, vid, type, cr, f);
        
        if(GlobalState.clauseType==1)
        {
            
            var token = localStorage.getItem("token");
            var t = [];
            var atrim = GlobalState.ifblock;
            
            setifblock([]);

            atrim.map((n, id)=>
            {
                if(id == GlobalState.ispopupdeleteClauseId)
                {  
                }
                else
                {
                    t = [...t, {then: n.then, list: n.list}]
                }
            })
            
            setifblock(t);

            if(GlobalState.clauseCre==1){

                console.log("trestan"); 
            

                var t = [];
                var id_d = '';
                GlobalState.dataset?.map((n, id)=>
                    n.name == GlobalState.activeDatasetClause?id_d=n.id:<></>
                )  
                var rules = [];
                var l = [];
                var l2 = [];
                GlobalState.ifblock.map((n, id)=>
                {
                    l = [];
                    n.list?.map((g, id2)=>
                    {
                        
                        if(g.type=="categorical")
                        {
                            l2 = [];
                            
                            g.operator?.map((v, f)=>{
                                l2 = [];
                                Array.isArray(v.value)? 
                                v.value?.map((gh)=>
                                {
                                    if(gh.check==true)
                                    {
                                        l2 = [...l2, gh.name]
                                    }
                                }
                                )
                                :
                                <></>

                                l = [...l, {column: g.activColumn, operator: v.operator, value: l2}]
                            })
                            
                        }
                        else
                        {
                            g.operator?.map((v, f)=>{
                                l = [...l, {column: g.activColumn, operator: v.operator, value: v.value}]
                            })
                        }
                        
                    }
                    )
                    rules = [...rules,{conditions: l, newValue: n.then} ]
                }
                )
                var token = localStorage.getItem("token");
                
                var attr = {
                    datasetId: GlobalState.activeDatasetClause,
                    rules: rules,
                    rewrite: true,
                    newColumnName: GlobalState.inputNameClause,
                    othersValue: GlobalState.elsevalClause
                };
                
                

                localStorage.setItem("countactivetime", Date.now());
                
                
            }
            else
            {
                changepopupdeleteClause();
            }
        }
        else
        {
            
            var t = [];
            var l = [];
            var l0 = [];
            var op = [];
            var atrim = GlobalState.ifblock;
            console.log(JSON.stringify(atrim) + "tred555568   -  "  + f + " - f")
            var VID = GlobalState.VId2;
            setifblock([]);
            atrim.map((n, id)=>
            {
                    
                    if(id == GlobalState.ispopupdeleteClauseId)
                    {
                        l = [];
                        
                        n.list?.map((y, id2)=>
                        {
                           
                            if(id2 == vid)
                            {
                                l0 = [];
                                y.operator.map((ty, ty2)=>
                                    ty2==f?
                                    <></>
                                    :
                                    l0 = [...l0, {operator:ty.operator, value:ty.value, select:ty.select}]
                                )
                               
                                if(l0&&l0.length>=1)
                                {
                                    l = [...l, {title: y.title, activColumn: y.activColumn||"", type: y.type||"", operator: l0}]
                                }
                                else
                                {
                                    
                                }
                                
                            }
                            else{
                                l = [...l, {title: y.title, activColumn: y.activColumn||"", type: y.type||"", operator: y.operator||""}]
                                
                            }
                        })
                        if(l.length>=1)
                        {
                            t = [...t, {then: n.then||"", list: l||[]}]
                        }
                        else
                        {
                            l = [{title:"if",activColumn:"",type:"",operator:[{operator:"",value:"",select:""}]}];
                            t = [...t, {then: n.then||"", list: l||[]}]
                        }
                        
                    }
                    else
                    {
                        t = [...t, {then: n.then||"", list: n.list||[]}]
                    }
            })
            console.log(JSON.stringify(t) + " - done")
            setifblock(t);
            
        }
    }
    const changesegmentationpagecenterAll = (a) =>{
        if(a!=0)
        {
            changesegmentationpagecenter1(1)
        }
        setActiveexportblock1(1);
        setActiveexportblock1(false);
        setActiveexportblock2(true);
        setNameDatasetprew(GlobalState.portraitsheduledeployname);
        setNameDatasetprew2(GlobalState.portraitsheduledeployname2);



        if(GlobalState.portraitsheduledeployevery=="daily")
        {
            setEvery({value: 'daily', label: 'Day'});
        }
        else if(GlobalState.portraitsheduledeployevery=="weekly")
        {
            setEvery({value: 'weekly', label: 'Week'});
        }
        else{
            setEvery({value: 'monthly', label: 'Month'});
        }
        const [left, right] = GlobalState.portraitsheduledeploystarttime.split('T');
        //const [l1, r2] = right?.split('.');
        const [h, m, s] = right?.split(':');
        setStartDate(left);
        var pid = h;
        if(pid>12)
        {
            pid = pid-12;
        }
        setHour(pid);
        setMinut(m);
        setCloseExport5(pid);
        setCloseExport6(m);

        setCloseExport1(GlobalState.portraitsheduledeployname);
        setCloseExport3(GlobalState.portraitsheduledeployevery);
        setCloseExport4(left);
    }
    const handleChangeEvery = (option) => {
        setEvery(option);
        console.log(option)
    };
    const minusnumpagesmodelsportraits0 = ()=>{
        minusnumpagesmodelsportraits();
        GetDataPortrait();
    }
    const plusnumpagesmodelsportraits0 = ()=>{
        plusnumpagesmodelsportraits(limit);
        GetDataPortrait();
    }
    const changesegmentationpage7 = ()=>{
        changesegmentationpage(7);
        setTextloadingcompleateddeploy('Processing the saving of deployment');
    }
    const setActiveexportblock01 = () =>{
        setActiveexportblock1(!activeexportblock1);
        setActiveexportblock2(false)
    }
    const setActiveexportblock02 = () =>{
        setActiveexportblock2(!activeexportblock2);
        setActiveexportblock1(false)
    }
    const getLinkOutline_error = ()=>{
        nameDatasetprew==""?
        setV1_export(true):
        <></>

        GlobalState.sheduleEvery==""?
        setV2_export(true):
        <></>

        GlobalState.sheduleHour==""?
        setV3_export(true):
        <></>

        GlobalState.sheduleMinute==""?
        setV4_export(true):
        <></>
        
        setTimeout(function(){
            setV1_export(false);
            setV2_export(false);
            setV3_export(false);
            setV4_export(false);
        }, 2000)




    }
    const changesegmentationpage0 = ()=>{

        if(GlobalState.segmentationpage=="3")
        {
            changepopupCloseSelectAttribute()
        }
        else if(GlobalState.segmentationpage=="4")
        {
            changepopupCloseSelectAttribute()
        }
        else if(GlobalState.segmentationpage=="5")
        {
            changepopupCloseSelectAttribute()
        }
        else if(GlobalState.segmentationpage=="101")
        {
            changepopupCloseSelectAttribute()
        }
        else if(GlobalState.segmentationpage=="7")
        {
            changepopupcloseShedule()
        }
        else
        {
            changesegmentationpage(2);
        }
        
    }
    const setNameDatasetprew01 = (a) =>{
        setNameDatasetprew(a);
        changePortraitsheduledeployname(a);
    }
    const setNameDatasetprew02 = (a) =>{
        setNameDatasetprew2(a);
        changePortraitsheduledeployname2(a);
    }

    // Слідкування за довжиною тегов в чекбоксі
    
    useEffect(() => {
        const el = blockRef.current;
        const observer = new ResizeObserver(() => {
            if (el) setSelect(el.offsetWidth);
        });

        if (el) observer.observe(el);

        return () => {
            if (el) observer.disconnect();
        };
    }, []);
    useEffect(() => {
        const el = blockRef.current;
        const observer = new ResizeObserver(() => {
            if (el) setSelect(el.offsetWidth);
            updateWord();
        });

        if (el) observer.observe(el);

        return () => {
            if (el) observer.disconnect();
        };
    }, [GlobalState.ifblock]);
    useEffect(() => {
        if (!blockRef2.current) return;
        const el = blockRef2.current;
        const observer = new ResizeObserver(() => {
            setSelect2(el.offsetWidth);
            updateWord();
        });
        observer.observe(el);

        return () => {
            observer.disconnect();
        };
    }, [blockRef2.current, GlobalState.ifblock]);

    

    const updateWord = () =>{
        var sim = 0;
        var word = 0;
        var wordlast = 0;
        var w = 0;
        var w2 = widthselect2 - 170;

        if(widthselect!=0)
        {
            w = widthselect - 170;
        }

        if(widthselect2!=0)
        {
            w = widthselect2 - 170;
        }

        var t = 0;
        console.log(w + "rfgdj")
        GlobalState.ifblock.map((n, id)=>
            n.list?.map((g, id2)=>
                g.activColumn!=""?
                    g.operator?.map((v, f)=>
                        g.type=='categorical'?
                            Array.isArray(v.value)? 
                            v.value?.map((n, id)=>
                                {
                                    if(n.name)
                                    {
                                        sim = sim + n.name?.length;
                                        if(n.check==true){
                                            wordlast = wordlast*1 + 1;
                                        }
                                        t = sim*6 + wordlast*25;
                                        if(t<w)
                                        {
                                            word = word + 1;
                                        }
                                    }
                                    else
                                    {
                                        sim = sim + n?.length;
                                        
                                        wordlast = wordlast*1 + 1;
                                        t = sim*7 + wordlast*25;

                                       
                                        if(t<w2)
                                        {
                                            word = word + 1;
                                        }
                                       
                                    } 
                                }     
                            )
                            :
                            <></>
                        :
                        <></>
                    )
                :
                <></>
            )
        )
        wordlast = wordlast*1 - word;
        setCountword(word);
        setCountwordLast(wordlast);
        console.log(word)
    }
    useEffect(() => {
        // updateWord();
                                
    }, [GlobalState.ifblock, widthselect, widthselect2]);

    
    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');      // 01..31
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 00..11 → +1
        const year = date.getFullYear();                          // 2025

        return `${day}.${month}.${year}`;
    };
    const setInputNameColumn0 = (a)=>{
        setInputNameColumn(a);
        var c = 0;
        GlobalState.activeportraits?.data?.map((n)=>
            n.name==a?c=1:<></>
        )
        if(c==1){
            setErrorNameAttr(true)
        }
        else
        {
            setErrorNameAttr(false)
        }
        
    }
    const changepopupCloseEditDeploy0 = () =>{

        var flag = false;
        if(GlobalState.portraitsheduledeployname != closeExport1)
        {
            flag = true;
            console.log('1')
           
        }
        if(GlobalState.sheduleEvery.value != closeExport3)
        {
            flag = true;
            console.log('2')
            
        }
        if(startDate != closeExport4)
        {
            flag = true;
            console.log('3')
            console.log(startDate)
            console.log(closeExport4)
        }
        if(GlobalState.sheduleHour != closeExport5)
        {
            flag = true;
            console.log('4')
        }
        if(GlobalState.sheduleMinute != closeExport6)
        {
            flag = true;
            console.log('5')
        }
        if(GlobalState.portraitsheduledeploycred && Object.keys(GlobalState.portraitsheduledeploycred).length > 0)
        {
            flag = true;
        }
        if(flag){
            changepopupCloseEditDeploy()
        }
        else
        {
            changesegmentationpagecenter1(4)
        }
        
    }

    return (
        <div className={GlobalState.loadsegmentations==1||GlobalState.loadsegmentations==2?'workspaceload segma':<></>}>
            {
                GlobalState.loadsegmentations==1?
                    <Loading text = {textloading}/>
                :
                GlobalState.loadsegmentations==2?
                    <LoadingCompleted text = {textloadingcompleated}/>
                :
                GlobalState.loadsegmentations==4?
                <div style={{marginTop:"30vh"}}>
                    <LoadingCompleted text = {'Processing the saving of deployment'}/>
                </div>
                :
                <div className="segment" >
                    {
                        GlobalState.segmentationpage=="11"||GlobalState.segmentationpage=="12"?
                        <></>
                        :
                        <div className='header-segment new_header-segment'>
                            <div className='custumer_header_segment'>
                                <div className='first_line_sliders'>
                                    <div className={GlobalState.segmentationpage=="2"?'createbut rty3':'createbut rty'} >
                                        {
                                            GlobalState.segmentationpage=="2"?
                                            <svg style={{cursor:"pointer"}} onClick={()=>changepopupaddSegment0()} className='hoverarrowcreate' width="40" height="39" viewBox="0 0 40 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path className='hoverarrowcreatepath' d="M39.1883 18.5664C39.5455 19.1852 39.5455 19.9476 39.1883 20.5664L30.593 35.4539C30.2357 36.0727 29.5755 36.4539 28.8609 36.4539L11.6703 36.4539C10.9558 36.4539 10.2955 36.0727 9.93827 35.4539L1.34297 20.5664C0.985709 19.9476 0.985709 19.1852 1.34297 18.5664L9.93827 3.67891C10.2955 3.06011 10.9558 2.67891 11.6703 2.67891L28.8609 2.67891C29.5755 2.67891 30.2357 3.06011 30.593 3.67891L39.1883 18.5664Z" fill="#F5C538" stroke="#F5C538"/>
                                                <path d="M20.7656 10.7539V27.3789" stroke="#020203" stroke-linecap="round"/>
                                                <path d="M12.4531 19.0664H29.0781" stroke="#020203" stroke-linecap="round"/>
                                            </svg>
                                            :
                                            <></>
                                        }
                                        {GlobalState.segmentationpage=="0"?"Customer Portraits":<></>}
                                        {GlobalState.segmentationpage=="1"?"Customer Portraits":<></>}
                                        {GlobalState.segmentationpage=="2"?<div className='crbucur' onClick={()=>changepopupaddSegment0()}>Add Product Attribute</div>:<></>}
                                        {GlobalState.segmentationpage=="3"?"Select Attribute":<></>}
                                        {GlobalState.segmentationpage=="4"?"Edit Attribute":<></>}
                                        {GlobalState.segmentationpage=="101"?"Edit Attribute":<></>}
                                        {GlobalState.segmentationpage=="5"?"Create Segmentation":<></>}
                                        {GlobalState.segmentationpage=="6"?
                                            <>
                                                <div>{langv?.segmentation?.deploy}</div>
                                                <div className='but_nead_deploy active'>
                                                    {langv?.segmentation?.input_table_check}
                                                </div>
                                                <div className='but_nead_deploy inactive'>
                                                    {langv?.segmentation?.output_table_connector}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        {GlobalState.segmentationpage=="7"?
                                            <>
                                                <div>{langv?.segmentation?.deploy}</div>
                                                <div className='but_nead_deploy'>
                                                {langv?.segmentation?.input_table_check}
                                                </div>
                                                <div className='but_nead_deploy active'>
                                                {langv?.segmentation?.output_table_connector}
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                    </div>
                                    {GlobalState.activedatasetSegment.nameSegment!==""?
                                        <svg  width="41" height="38" viewBox="0 0 41 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M39.5398 18.5C39.8971 19.1188 39.8971 19.8812 39.5398 20.5L30.9445 35.3875C30.5873 36.0063 29.927 36.3875 29.2125 36.3875L12.0219 36.3875C11.3074 36.3875 10.6471 36.0063 10.2898 35.3875L1.69454 20.5C1.33727 19.8812 1.33727 19.1188 1.69454 18.5L10.2898 3.6125C10.6471 2.9937 11.3074 2.6125 12.0219 2.6125L29.2125 2.6125C29.927 2.6125 30.5873 2.9937 30.9445 3.6125L39.5398 18.5Z" fill="#F4F5F7" stroke="#F4F5F7"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6172 10.6875C21.6172 10.4114 21.3933 10.1875 21.1172 10.1875C20.841 10.1875 20.6172 10.4114 20.6172 10.6875V18.5H12.8047C12.5285 18.5 12.3047 18.7239 12.3047 19C12.3047 19.2761 12.5285 19.5 12.8047 19.5H20.6172V27.3125C20.6172 27.5886 20.841 27.8125 21.1172 27.8125C21.3933 27.8125 21.6172 27.5886 21.6172 27.3125V19.5H29.4297C29.7058 19.5 29.9297 19.2761 29.9297 19C29.9297 18.7239 29.7058 18.5 29.4297 18.5H21.6172V10.6875Z" fill="#020203" fill-opacity="0.2"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6172 10.6875C21.6172 10.4114 21.3933 10.1875 21.1172 10.1875C20.841 10.1875 20.6172 10.4114 20.6172 10.6875V18.5H12.8047C12.5285 18.5 12.3047 18.7239 12.3047 19C12.3047 19.2761 12.5285 19.5 12.8047 19.5H20.6172V27.3125C20.6172 27.5886 20.841 27.8125 21.1172 27.8125C21.3933 27.8125 21.6172 27.5886 21.6172 27.3125V19.5H29.4297C29.7058 19.5 29.9297 19.2761 29.9297 19C29.9297 18.7239 29.7058 18.5 29.4297 18.5H21.6172V10.6875Z" fill="black" fill-opacity="0.2"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6172 10.6875C21.6172 10.4114 21.3933 10.1875 21.1172 10.1875C20.841 10.1875 20.6172 10.4114 20.6172 10.6875V18.5H12.8047C12.5285 18.5 12.3047 18.7239 12.3047 19C12.3047 19.2761 12.5285 19.5 12.8047 19.5H20.6172V27.3125C20.6172 27.5886 20.841 27.8125 21.1172 27.8125C21.3933 27.8125 21.6172 27.5886 21.6172 27.3125V19.5H29.4297C29.7058 19.5 29.9297 19.2761 29.9297 19C29.9297 18.7239 29.7058 18.5 29.4297 18.5H21.6172V10.6875Z" fill="black" fill-opacity="0.2"/>
                                        </svg>
                                        :
                                        <></>
                                    }
                                </div>
                            
                                <div className='openpopdeploy_tooltipe' onClick={()=>changepopupDeployment0()}>
                                    <div className={GlobalState.segmentationpage=="1"?'betta_line firsta':GlobalState.segmentationpage=="2"?'betta_line trestan':'betta_line actua'}>
                                        <div className='betta' > 
                                            <div className='betta_inside'>
                                                {langv?.beta?.head_text}
                                            </div>
                                        </div>
                                        {GlobalState.segmentationpage=="2"?
                                            <>
                                                <div className="deleteTable" onClick={()=>changepopupdeleteTable()}>
                                                    <svg className='def_delete' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.8">
                                                        <path d="M10.4 6.8H13.6C13.6 6.37565 13.4314 5.96869 13.1314 5.66863C12.8313 5.36857 12.4243 5.2 12 5.2C11.5757 5.2 11.1687 5.36857 10.8686 5.66863C10.5686 5.96869 10.4 6.37565 10.4 6.8ZM9.2 6.8C9.2 6.4323 9.27242 6.0682 9.41314 5.72849C9.55385 5.38877 9.7601 5.08011 10.0201 4.8201C10.2801 4.5601 10.5888 4.35385 10.9285 4.21314C11.2682 4.07242 11.6323 4 12 4C12.3677 4 12.7318 4.07242 13.0715 4.21314C13.4112 4.35385 13.7199 4.5601 13.9799 4.8201C14.2399 5.08011 14.4461 5.38877 14.5869 5.72849C14.7276 6.0682 14.8 6.4323 14.8 6.8H19.4C19.5591 6.8 19.7117 6.86321 19.8243 6.97574C19.9368 7.08826 20 7.24087 20 7.4C20 7.55913 19.9368 7.71174 19.8243 7.82426C19.7117 7.93679 19.5591 8 19.4 8H18.344L17.408 17.6888C17.3362 18.4312 16.9904 19.1202 16.4381 19.6215C15.8859 20.1227 15.1666 20.4003 14.4208 20.4H9.5792C8.83349 20.4001 8.11448 20.1224 7.56236 19.6212C7.01024 19.1199 6.66459 18.431 6.5928 17.6888L5.656 8H4.6C4.44087 8 4.28826 7.93679 4.17574 7.82426C4.06321 7.71174 4 7.55913 4 7.4C4 7.24087 4.06321 7.08826 4.17574 6.97574C4.28826 6.86321 4.44087 6.8 4.6 6.8H9.2ZM10.8 10.6C10.8 10.4409 10.7368 10.2883 10.6243 10.1757C10.5117 10.0632 10.3591 10 10.2 10C10.0409 10 9.88826 10.0632 9.77574 10.1757C9.66321 10.2883 9.6 10.4409 9.6 10.6V16.6C9.6 16.7591 9.66321 16.9117 9.77574 17.0243C9.88826 17.1368 10.0409 17.2 10.2 17.2C10.3591 17.2 10.5117 17.1368 10.6243 17.0243C10.7368 16.9117 10.8 16.7591 10.8 16.6V10.6ZM13.8 10C13.9591 10 14.1117 10.0632 14.2243 10.1757C14.3368 10.2883 14.4 10.4409 14.4 10.6V16.6C14.4 16.7591 14.3368 16.9117 14.2243 17.0243C14.1117 17.1368 13.9591 17.2 13.8 17.2C13.6409 17.2 13.4883 17.1368 13.3757 17.0243C13.2632 16.9117 13.2 16.7591 13.2 16.6V10.6C13.2 10.4409 13.2632 10.2883 13.3757 10.1757C13.4883 10.0632 13.6409 10 13.8 10ZM7.7872 17.5736C7.83035 18.0189 8.0378 18.4322 8.36909 18.7329C8.70039 19.0336 9.1318 19.2001 9.5792 19.2H14.4208C14.8682 19.2001 15.2996 19.0336 15.6309 18.7329C15.9622 18.4322 16.1697 18.0189 16.2128 17.5736L17.1392 8H6.8608L7.7872 17.5736Z" fill="#FF3B30"/>
                                                        </g>
                                                    </svg>
                                                    <svg className='hover_delete' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.4 6.8H13.6C13.6 6.37565 13.4314 5.96869 13.1314 5.66863C12.8313 5.36857 12.4243 5.2 12 5.2C11.5757 5.2 11.1687 5.36857 10.8686 5.66863C10.5686 5.96869 10.4 6.37565 10.4 6.8ZM9.2 6.8C9.2 6.4323 9.27242 6.0682 9.41314 5.72849C9.55385 5.38877 9.7601 5.08011 10.0201 4.8201C10.2801 4.5601 10.5888 4.35385 10.9285 4.21314C11.2682 4.07242 11.6323 4 12 4C12.3677 4 12.7318 4.07242 13.0715 4.21314C13.4112 4.35385 13.7199 4.5601 13.9799 4.8201C14.2399 5.08011 14.4461 5.38877 14.5869 5.72849C14.7276 6.0682 14.8 6.4323 14.8 6.8H19.4C19.5591 6.8 19.7117 6.86321 19.8243 6.97574C19.9368 7.08826 20 7.24087 20 7.4C20 7.55913 19.9368 7.71174 19.8243 7.82426C19.7117 7.93679 19.5591 8 19.4 8H18.344L17.408 17.6888C17.3362 18.4312 16.9904 19.1202 16.4381 19.6215C15.8859 20.1227 15.1666 20.4003 14.4208 20.4H9.5792C8.83349 20.4001 8.11448 20.1224 7.56236 19.6212C7.01024 19.1199 6.66459 18.431 6.5928 17.6888L5.656 8H4.6C4.44087 8 4.28826 7.93679 4.17574 7.82426C4.06321 7.71174 4 7.55913 4 7.4C4 7.24087 4.06321 7.08826 4.17574 6.97574C4.28826 6.86321 4.44087 6.8 4.6 6.8H9.2ZM10.8 10.6C10.8 10.4409 10.7368 10.2883 10.6243 10.1757C10.5117 10.0632 10.3591 10 10.2 10C10.0409 10 9.88826 10.0632 9.77574 10.1757C9.66321 10.2883 9.6 10.4409 9.6 10.6V16.6C9.6 16.7591 9.66321 16.9117 9.77574 17.0243C9.88826 17.1368 10.0409 17.2 10.2 17.2C10.3591 17.2 10.5117 17.1368 10.6243 17.0243C10.7368 16.9117 10.8 16.7591 10.8 16.6V10.6ZM13.8 10C13.9591 10 14.1117 10.0632 14.2243 10.1757C14.3368 10.2883 14.4 10.4409 14.4 10.6V16.6C14.4 16.7591 14.3368 16.9117 14.2243 17.0243C14.1117 17.1368 13.9591 17.2 13.8 17.2C13.6409 17.2 13.4883 17.1368 13.3757 17.0243C13.2632 16.9117 13.2 16.7591 13.2 16.6V10.6C13.2 10.4409 13.2632 10.2883 13.3757 10.1757C13.4883 10.0632 13.6409 10 13.8 10ZM7.7872 17.5736C7.83035 18.0189 8.0378 18.4322 8.36909 18.7329C8.70039 19.0336 9.1318 19.2001 9.5792 19.2H14.4208C14.8682 19.2001 15.2996 19.0336 15.6309 18.7329C15.9622 18.4322 16.1697 18.0189 16.2128 17.5736L17.1392 8H6.8608L7.7872 17.5736Z" fill="#FF3B30"/>
                                                    </svg>

                                                    {langv?.segmentation?.delete_table}
                                                </div>
                                                {
                                                    GlobalState.activeportraits?.data?.length>1?
                                                    <div className={GlobalState.activeportraits?.data?.length>1?'button_deploy':'button_deploy inactive'} onClick={()=>changesegmentationpage6(6)}>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 2.99992L7.45117 7.05036L8.36016 7.87327L11.3571 5.2054V15.1055H12.6428V5.2054L15.6385 7.87213L16.5488 7.05036L12 2.99992Z" fill="black"/>
                                                            <path d="M3 19.8555V21H4.2857H11.9999H19.7141H20.9998V19.8555H3Z" fill="black"/>
                                                        </svg>
                                                        {langv?.segmentation?.deploy}
                                                    </div>
                                                    :
                                                    <div className={GlobalState.activeportraits?.data?.length>1?'button_deploy':'button_deploy inactive'}>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.15">
                                                            <path d="M12 2.99992L7.45117 7.05036L8.36016 7.87327L11.3571 5.2054V15.1055H12.6428V5.2054L15.6385 7.87213L16.5488 7.05036L12 2.99992Z" fill="black"/>
                                                            <path d="M3 19.8555V21H4.2857H11.9999H19.7141H20.9998V19.8555H3Z" fill="black"/>
                                                            </g>
                                                        </svg>

                                                        {langv?.segmentation?.deploy}
                                                    </div>
                                                }
                                            
                                            </>
                                            :
                                            <></>
                                        }
                                        {GlobalState.segmentationpage>="3"?
                                            <div class="dataset_head_back" onClick={()=>changesegmentationpage0(2)}>
                                                <svg class="def_icon" width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path>
                                                </svg>
                                                <svg class="hov_icon" width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#41A8B1" stroke="#41A8B1"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path>
                                                </svg>
                                            </div>
                                            :
                                            <></>
                                        }
                                        {GlobalState.segmentationpage=="101"?
                                            <div class="dataset_head_back" onClick={()=>changesegmentationpage0(2)}>
                                                <svg class="def_icon" width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path>
                                                </svg>
                                                <svg class="hov_icon" width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#41A8B1" stroke="#41A8B1"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M21.9492 11.0488L12.0497 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="#020203" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path><path d="M12.0508 11.0488L21.9503 20.9483" stroke="black" stroke-opacity="0.2" stroke-linecap="round"></path>
                                                </svg>
                                            </div>
                                            :
                                            <></>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='custumer_header_segment_line'>
                            </div>
                        </div>
                    }
                    <div className='body-segment new_form-element'>
                            {
                                GlobalState.segmentationpage=="0"?
                                <>
                                    <ListSermentations/>
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="1"?
                                <>
                                    <StartPage/>
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="2"?
                                <>
                                    <SecondPage 
                                        langv={langv}
                                        scrollRef={scrollRef}
                                        limit={limit}
                                        scrollPosition={scrollPosition}
                                        minusnumpagesmodelsportraits0={minusnumpagesmodelsportraits0}
                                        plusnumpagesmodelsportraits0={plusnumpagesmodelsportraits0}
                                        changesegmentationpage01={changesegmentationpage01} 
                                        labels={labels}
                                        datalabels={datalabels}
                                    />
                                    
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="3"?
                                <>
                                    <SelectAttributeFilePage
                                        langv={langv}
                                        DropdownIndicator={DropdownIndicator}
                                        optionscsw={optionscsw}
                                        customStyles={customStyles}
                                        activeDataset={activeDataset}
                                        setOptionmetricsattr1={setOptionmetricsattr1}
                                        setOpenselect={setOpenselect}
                                        masscheca={masscheca}
                                        masscheca_order={masscheca_order}
                                        checkmultiselect={checkmultiselect}
                                        openselect={openselect}
                                        textinselect={textinselect}
                                        inputNameColumn={inputNameColumn}
                                        AddAttributesFile={AddAttributesFile}
                                        blockRef = {blockRef}
                                        countword={countword}
                                        countnowword={countnowword}
                                        countwordLast={countwordLast}
                                        setOpenselectful={setOpenselectful}
                                        setOpenselectful2={setOpenselectful2}
                                    />
                                    
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="4"?
                                <>
                                    <EditAttributeFilePage
                                        langv={langv}
                                        inputt1={inputt1}
                                        inputt2={inputt2}
                                        inputt4={inputt4}
                                        columnName={columnName}
                                        setInputt1={setInputt1}
                                        EditAttributeName={EditAttributeName}
                                        deleteColumn={deleteColumn}        
                                    />                        
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="5"?
                                <>
                                    <CreateSegmentation
                                        langv={langv}
                                        errorNameAttr={errorNameAttr}
                                        inputNameColumn={inputNameColumn}
                                        DropdownIndicator={DropdownIndicator}
                                        optionscsw={optionscsw}
                                        customStyles={customStyles}
                                        activeDataset={activeDataset}
                                        setInputNameColumn0={setInputNameColumn0}
                                        updateselect={updateselect}
                                        optionif={optionif}
                                        customStylesoper={customStylesoper}
                                        setOptionmetrics1={setOptionmetrics1}
                                        setOptionmetricsforcreate={setOptionmetricsforcreate}
                                        elseval={elseval}
                                        optionoper={optionoper}
                                        setOperator={setOperator}
                                        setValueselect={setValueselect}
                                        addNewLine={addNewLine}
                                        addNewLinesubsub2={addNewLinesubsub2}
                                        addNewLinesub={addNewLinesub}
                                        optionopercat={optionopercat}
                                        blockRef={blockRef}
                                        textinselect={textinselect}
                                        countword={countword}
                                        countnowword={countnowword}
                                        setOpenselectful={setOpenselectful}
                                        checkmultiselectmulty={checkmultiselectmulty}
                                        countwordLast={countwordLast}
                                        setOpenselectful2={setOpenselectful2}
                                        changeThen={changeThen}
                                        setElseval={setElseval}
                                        changepopupdeleteClauseInside={changepopupdeleteClauseInside}
                                        changepopupdeleteClause={changepopupdeleteClause}
                                        EditAttributeNameAndParam={EditAttributeNameAndParam}
                                    />
                                
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="101"?
                                <>
                                    <EditSegmentation
                                        langv={langv}
                                        inputNameColumn={inputNameColumn}
                                        editDataset={editDataset}
                                        activeDataset={activeDataset}
                                        textinselect={textinselect}
                                        DropdownIndicator={DropdownIndicator}
                                        optionif={optionif}
                                        customStylesif={customStylesif}
                                        optionoper={optionoper}
                                        customStylesoper={customStylesoper}
                                        elseval={elseval}
                                        setInputNameColumn={setInputNameColumn}
                                        setOptionmetrics1={setOptionmetrics1}
                                        optionopercat={optionopercat}
                                        blockRef2={blockRef2}
                                        countnowword={countnowword}
                                        countword={countword}
                                        setOperator={setOperator}
                                        setOpenselectful={setOpenselectful}
                                        checkmultiselectmulty={checkmultiselectmulty}
                                        setOpenselectful2={setOpenselectful2}
                                        addNewLinesubsub3={addNewLinesubsub3}
                                        setValueselect={setValueselect}
                                        addNewLinesub={addNewLinesub}
                                        changeThen={changeThen}
                                        setElseval={setElseval}
                                        changepopupdeleteClauseInside={changepopupdeleteClauseInside}
                                        deleteColumn={deleteColumn}
                                        EditAttributeNameAndParam={EditAttributeNameAndParam}
                                        inputt4={inputt4}
                                    />
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="6"?
                                <>
                                    <DeployFirstPage
                                        langv={langv}
                                        deployprew={deployprew}
                                        limit={limit}
                                        formatDate={formatDate}
                                        changesegmentationpage7={changesegmentationpage7}
                                    />
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="7"?
                                <>
                                    <DeploySecondPage
                                        langv={langv}
                                        activeexportblock1={activeexportblock1}
                                        activeexportblock2={activeexportblock2}
                                        typeDeploy={typeDeploy}
                                        setActiveexportblock01={setActiveexportblock01}
                                        AttachmentBoxAnaliticsbigexport={AttachmentBoxAnaliticsbigexport}
                                        attachments={attachments}
                                        setAttachments={setAttachments}
                                        nameDatasetprew={nameDatasetprew}
                                        load={load}
                                        setLoad={setLoad}
                                        DropdownIndicator={DropdownIndicator}
                                        days={days}
                                        customStyles2={customStyles2}
                                        v1_export={v1_export}
                                        v2_export={v2_export}
                                        v3_export={v3_export}
                                        v4_export={v4_export}
                                        handleChangeEvery={handleChangeEvery}
                                        DatePicker={DatePicker}
                                        startDate={startDate}
                                        polden={polden}
                                        setNameDatasetprew01={setNameDatasetprew01}
                                        setStartDate={setStartDate}
                                        setHour0={setHour0}
                                        setMinut0={setMinut0}
                                        setPolden={setPolden}
                                        PostLinkOutlineBig={PostLinkOutlineBig}
                                        setTextloadingcompleated={setTextloadingcompleated}
                                        Loading={Loading}
                                        formatDate={formatDate}
                                        changesegmentationpagecenterAll={changesegmentationpagecenterAll}
                                        changepopupCloseEditDeploy0={changepopupCloseEditDeploy0}
                                        textloadingdeployexport={textloadingdeployexport}
                                        LoadingCompleted={LoadingCompleted}
                                        textloadingcompleatedexport={textloadingcompleatedexport}
                                        changepopupdeleteShedule={changepopupdeleteShedule}
                                        setActiveexportblock02={setActiveexportblock02}
                                        setTypeDeploy={setTypeDeploy}
                                        AttachmentBoxAnaliticsbigOnetimeexport={AttachmentBoxAnaliticsbigOnetimeexport}
                                        nameDatasetprew2={nameDatasetprew2}
                                        setNameDatasetprew02={setNameDatasetprew02}
                                        PostLinkOutlineBigNoSchedule={PostLinkOutlineBigNoSchedule}
                                        setNameDatasetprew={setNameDatasetprew}
                                        setNameDatasetprew2={setNameDatasetprew2}
                                        setTextloadingcompleatedexport={setTextloadingcompleatedexport}
                                        textloadingdeployexportonetime={textloadingdeployexportonetime}
                                        getLinkOutline={getLinkOutline}
                                        getLinkOutline_error={getLinkOutline_error}
                                    />
                                    
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="8"?
                                <>
                                    {
                                        load==1?
                                        <div style={{marginTop:"150px"}}>
                                          <Loading text = {textloadingdeploy}/>
                                        </div>
                                       
                                        :
                                        load==2?
                                        <div style={{marginTop:"150px"}}>
                                          <LoadingCompleted text = {textloadingcompleateddeploy}/>
                                        </div>
                                        
                                        :
                                        load==4?
                                        <LoadingFail text = {textloadingcompleated}/>
                                        :
                                        <></>
                                        
                                    }
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="11"?
                                <>
                                    <div style={{marginTop:"calc(50vh - 80px)"}}>
                                        <Loading text = {textloadingdeployexport}/>
                                    </div>
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="13"?
                                <>
                                    <div style={{marginTop:"calc(50vh - 80px)"}}>
                                        <Loading text = {textloadingdeployexportonetime}/>
                                    </div>
                                </>
                                :
                                <></>
                            }
                            {
                                GlobalState.segmentationpage=="12"?
                                <>
                                    <div style={{marginTop:"calc(50vh - 80px)"}}>
                                        <LoadingCompleted text = {textloadingcompleatedexport}/>
                                    </div>
                                </>
                                :
                                <></>
                            }
                    </div>
                </div>
            }
        </div>
    );
})

export default Sidebar;
